import { pbx_group_breadcrumbs } from './groups';
import { pbx_contact_breadcrumbs } from './contacts';
import { pbx_sip_breadcrumbs } from './sip-accounts';

export const pbx_operators_breadcrumbs = [
  ...pbx_group_breadcrumbs,
  ...pbx_contact_breadcrumbs,
  ...pbx_sip_breadcrumbs
];
